var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.009,
    height: 33.19,
    viewBox: "0 0 113.009 33.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5653",
    "data-name": "Group 5653",
    transform: "translate(-251 -97.616)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 3.154,
    cy: 3.154,
    r: 3.154,
    transform: "translate(273.897 118.447)",
    fill: "#439037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9066",
    "data-name": "Path 9066",
    d: "M57.623,50.177c-.244.253-.451.361-.776.108-5.184-4.061-11.085-5.08-17.46-4.061A21.656,21.656,0,0,0,31.2,49.834c-1.354,1-1.354.988-2.567-.2a13.789,13.789,0,0,0-1.006-.984c-.537-.424-.582-.749,0-1.191a23.913,23.913,0,0,1,3.709-2.441h0l.153-.072a20.623,20.623,0,0,1,6.05-2.4A25.135,25.135,0,0,1,57.393,45.71c.749.451,1.444,1.015,2.17,1.516.388.266.528.5.108.9C58.954,48.769,58.291,49.477,57.623,50.177Z",
    transform: "translate(233.482 55.868)",
    fill: "#439037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9067",
    "data-name": "Path 9067",
    d: "M57.868,64.46A12.673,12.673,0,0,0,52,62.254a13.535,13.535,0,0,0-9.6,2.355c-.578.388-.9.411-1.354-.122a21.565,21.565,0,0,0-1.8-1.8c-.37-.343-.316-.564.059-.83a12.827,12.827,0,0,1,2.522-1.575,17.6,17.6,0,0,1,12.182-1.742,15.967,15.967,0,0,1,7.011,3.235c.415.307,0,.451-.131.636-.609.641-1.268,1.241-1.845,1.908a.74.74,0,0,1-1.173.144Z",
    transform: "translate(227.015 46.877)",
    fill: "#439037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9068",
    "data-name": "Path 9068",
    d: "M15.488,89.029a6.65,6.65,0,0,0,2.256-.361,6.555,6.555,0,0,0,1.5-.708l1.71,3.393a7.282,7.282,0,0,1-2.143,1.083,10.643,10.643,0,0,1-3.609.55,9.844,9.844,0,0,1-3.659-.681,9.411,9.411,0,0,1-3.014-1.917,8.956,8.956,0,0,1-2.057-2.906,8.753,8.753,0,0,1-.744-3.609,8.92,8.92,0,0,1,.735-3.609A9.023,9.023,0,0,1,8.5,77.344a9.416,9.416,0,0,1,3.018-1.931,9.835,9.835,0,0,1,3.668-.686,10.652,10.652,0,0,1,3.609.546,7.282,7.282,0,0,1,2.143,1.083l-1.71,3.393a6.013,6.013,0,0,0-1.5-.713,6.767,6.767,0,0,0-2.256-.356,6.122,6.122,0,0,0-2.382.424,4.755,4.755,0,0,0-2.707,2.811,5.712,5.712,0,0,0-.334,1.94,5.8,5.8,0,0,0,.334,1.958,4.755,4.755,0,0,0,1.015,1.66,4.805,4.805,0,0,0,1.7,1.16A6.208,6.208,0,0,0,15.488,89.029Z",
    transform: "translate(245.271 37.769)",
    fill: "#205c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9069",
    "data-name": "Path 9069",
    d: "M43.589,83.785a9.357,9.357,0,0,1,.681-3.609,8.906,8.906,0,0,1,1.908-2.906,8.739,8.739,0,0,1,2.887-1.936,9.628,9.628,0,0,1,7.183,0,8.681,8.681,0,0,1,2.865,1.954,8.883,8.883,0,0,1,1.908,2.928,9.524,9.524,0,0,1,.672,3.609,9.727,9.727,0,0,1-.654,3.609A8.6,8.6,0,0,1,56.3,92.294a9.411,9.411,0,0,1-3.65.695,9.56,9.56,0,0,1-3.7-.695,8.464,8.464,0,0,1-2.865-1.945,8.735,8.735,0,0,1-1.863-2.964,9.926,9.926,0,0,1-.636-3.6Zm4.155,0a5.915,5.915,0,0,0,.623,2.707,4.755,4.755,0,0,0,8.563.041,6.316,6.316,0,0,0,0-5.459,5.026,5.026,0,0,0-1.723-1.945,4.868,4.868,0,0,0-5.116,0,5.026,5.026,0,0,0-1.723,1.945A5.915,5.915,0,0,0,47.745,83.785Z",
    transform: "translate(224.492 37.816)",
    fill: "#205c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9070",
    "data-name": "Path 9070",
    d: "M107.548,75.39V93.031h-3.984V82.654l.171-2.951-.681,3.379-2.964,8.541H96.174l-2.955-8.55-.668-3.379.176,2.951V93.022h-4V75.39h5.613L97.9,87.161l.239,1.4.244-1.4,3.555-11.771Z",
    transform: "translate(199.717 37.404)",
    fill: "#205c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9071",
    "data-name": "Path 9071",
    d: "M137.72,75.39h4V89.53h6.4v3.5h-10.4Z",
    transform: "translate(172.83 37.404)",
    fill: "#205c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9072",
    "data-name": "Path 9072",
    d: "M166.84,75.39h4V93.031h-4Z",
    transform: "translate(156.848 37.404)",
    fill: "#205c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9073",
    "data-name": "Path 9073",
    d: "M186.24,79.049l.293.054V93.031H182.54V75.39h5.45l7.151,13.9-.293.054V75.39h4V93.031h-5.482Z",
    transform: "translate(148.231 37.404)",
    fill: "#205c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9074",
    "data-name": "Path 9074",
    d: "M232.251,83.917l6.709,9.114h-4.773l-5.414-7.71v7.71H224.78V75.39h3.993v7.219l5-7.219h4.512Z",
    transform: "translate(125.049 37.404)",
    fill: "#205c95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComlink);
export default __webpack_public_path__ + "static/media/comlink.895f0790d71471075f870b1bdd418e4a.svg";
export { ForwardRef as ReactComponent };